import { prop } from 'datx';

import { Resource } from '@/lib/datx-jsonapi-react';
import { ThinLecture } from '@/resources/ThinLecture';

export class ProfileContact extends Resource {
  public static type = 'profile_contact';

  @prop
  public sender_name: string;

  @prop
  public sender_email: string;

  @prop
  public recipient_email: string;

  @prop
  public message: string;

  @prop.toOne('lectures')
  lecture: ThinLecture;
}
